// Per-canton unique content for the 5 canton SEO pages.

export const CANTONS_DATA = {
    vaud: {
        slug: "vaud",
        name: "Vaud",
        short: "VD",
        mainCity: "Lausanne",
        h1: "Rachat de voiture dans le canton de Vaud",
        locationLabel: "dans le canton de Vaud",
        finalCtaTitle: "Vendez votre voiture dans le canton de Vaud en 24h",
        metaTitle: "Rachat voiture Vaud — Cash en 24h | Capital Automobile",
        metaDescription:
            "Rachat de votre voiture cash en 24h dans le canton de Vaud — Lausanne, Montreux, Yverdon, Nyon, Vevey. Évaluation gratuite, déplacement offert.",
        intro:
            "Capital Automobile est implantée à Ecublens, au cœur du canton de Vaud. Nous rachetons cash, sous 24 heures, des véhicules d'occasion partout sur le territoire vaudois : à Lausanne, Vevey, Montreux, Nyon, Yverdon-les-Bains, ou dans toute autre commune. Notre proximité immédiate avec la majorité du canton nous permet souvent d'effectuer le déplacement le jour même de votre demande. L'évaluation est gratuite, sans engagement, et nous nous occupons de l'ensemble des démarches administratives, y compris la désimmatriculation auprès du Service des automobiles vaudois.",
        cities: [
            "Lausanne",
            "Montreux",
            "Yverdon-les-Bains",
            "Nyon",
            "Vevey",
            "Renens",
            "Pully",
            "Morges",
            "Lutry",
            "Ecublens",
        ],
        trust:
            "Notre siège vaudois à Ecublens, à quelques minutes de Lausanne, fait du canton de Vaud notre zone de prédilection. Disponible 7j/7 de 7h à 22h, notre équipe se déplace gratuitement et peut intervenir le jour même selon les disponibilités. C'est la promesse d'un service ultra-réactif et proche de chez vous.",
        miniFaq: [
            {
                q: "Combien de temps pour un rachat à Lausanne ?",
                a: "Lausanne étant à quelques minutes de notre siège d'Ecublens, l'intervention le jour même est fréquemment possible. Une offre ferme vous parvient sous 24h, avec paiement cash le jour de la reprise.",
            },
            {
                q: "Rachetez-vous à Yverdon et dans la Broye ?",
                a: "Oui, gratuitement. Yverdon-les-Bains et l'ensemble de la Broye vaudoise font partie de notre zone standard — comptez généralement 24 à 48h entre votre demande et la reprise du véhicule.",
            },
            {
                q: "Prix moyen de rachat pour une voiture d'occasion dans le canton de Vaud en 2026 ?",
                a: "Le prix moyen d'un véhicule d'occasion racheté dans le canton de Vaud oscille entre 4 000 et 18 000 CHF selon marque, âge et kilométrage. Nos experts consultent Eurotax et l'évolution récente du marché romand pour proposer une offre juste.",
            },
            {
                q: "Comment se passe le déplacement à domicile dans le canton de Vaud ?",
                a: "Nous fixons un rendez-vous au créneau qui vous arrange (7j/7, 7h-22h), venons gratuitement à votre adresse dans tout le canton, évaluons le véhicule sur place en 20-30 minutes, puis payons cash ou par virement instantané.",
            },
        ],
    },
    geneve: {
        slug: "geneve",
        name: "Genève",
        short: "GE",
        mainCity: "Genève",
        h1: "Rachat de voiture à Genève",
        locationLabel: "à Genève",
        finalCtaTitle: "Vendez votre voiture à Genève en 24h",
        metaTitle: "Rachat voiture Genève — Cash en 24h | Capital Automobile",
        metaDescription:
            "Rachat voiture à Genève : offre cash sous 24h, déplacement gratuit à Genève, Carouge, Vernier, Meyrin. Spécialiste export et plaques GE.",
        intro:
            "Capital Automobile rachète votre voiture cash à Genève, dans toutes les communes du canton : Genève centre, Carouge, Vernier, Meyrin, Onex, Lancy ou Versoix. Notre équipe se déplace gratuitement sur l'ensemble du territoire genevois, du Petit-Saconnex aux Trois-Chêne. Spécialistes des plaques GE et de la procédure de désimmatriculation cantonale, nous gérons aussi régulièrement des dossiers d'export vers la France voisine et au-delà. Recevez une offre ferme sous 24h, paiement cash le jour de la prise en charge.",
        cities: [
            "Genève",
            "Carouge",
            "Vernier",
            "Meyrin",
            "Onex",
            "Lancy",
            "Versoix",
            "Plan-les-Ouates",
            "Thônex",
            "Chêne-Bougeries",
        ],
        trust:
            "Le canton de Genève, frontalier et cosmopolite, nous est familier : nos équipes maîtrisent la procédure de désimmatriculation au Service cantonal des véhicules et les formalités d'export. Nous nous y déplaçons régulièrement, gratuitement, et adaptons nos rendez-vous aux horaires des frontaliers.",
        miniFaq: [
            {
                q: "Rachetez-vous les voitures avec plaques GE frontalières ?",
                a: "Oui, nous rachetons couramment des véhicules avec plaques genevoises appartenant à des frontaliers domiciliés en France voisine. Nous vérifions au préalable la conformité auprès du Service cantonal des véhicules et gérons ensuite la désimmatriculation.",
            },
            {
                q: "Combien de temps pour un rachat cash à Genève ?",
                a: "Comptez 24h pour l'offre ferme et généralement 24 à 48h pour la reprise sur place, paiement cash ou virement instantané le jour même à Genève centre, Carouge, Vernier ou Meyrin.",
            },
            {
                q: "Rachetez-vous à Carouge, Vernier et Meyrin ?",
                a: "Oui, gratuitement, dans toutes les communes du canton — Carouge, Vernier, Meyrin, Onex, Lancy, Plan-les-Ouates, Thônex ou Chêne-Bougeries incluses.",
            },
            {
                q: "Prix moyen de rachat à Genève ?",
                a: "Le canton de Genève affiche un marché légèrement au-dessus de la moyenne romande : une voiture d'occasion en bon état se rachète en général entre 5 000 et 22 000 CHF, avec une décote plus douce sur les modèles premium très demandés à l'export.",
            },
        ],
    },
    fribourg: {
        slug: "fribourg",
        name: "Fribourg",
        short: "FR",
        mainCity: "Fribourg",
        h1: "Rachat de voiture dans le canton de Fribourg",
        locationLabel: "dans le canton de Fribourg",
        finalCtaTitle: "Vendez votre voiture dans le canton de Fribourg en 24h",
        metaTitle: "Rachat voiture Fribourg — Cash en 24h | Capital Automobile",
        metaDescription:
            "Rachat de votre voiture dans le canton de Fribourg : Fribourg, Bulle, Morat, Estavayer. Paiement cash 24h, déplacement gratuit, FR/DE.",
        intro:
            "Capital Automobile rachète votre voiture dans tout le canton de Fribourg : à Fribourg, Bulle, Morat, Estavayer-le-Lac, Châtel-Saint-Denis ou Villars-sur-Glâne. Que vous habitiez la Sarine, la Gruyère, le Lac, la Singine ou la Glâne, nous nous déplaçons gratuitement chez vous, sous 24 heures. Notre équipe bilingue français/allemand est à l'aise dans la partie alémanique comme romande du canton. Offre ferme sous 24h, paiement cash le jour même.",
        cities: [
            "Fribourg",
            "Bulle",
            "Morat",
            "Estavayer-le-Lac",
            "Châtel-Saint-Denis",
            "Villars-sur-Glâne",
            "Marly",
            "Düdingen",
            "Romont",
            "Gibloux",
        ],
        trust:
            "Le canton de Fribourg, bilingue et étendu de la plaine aux Préalpes, requiert une équipe flexible : la nôtre intervient aussi bien en français qu'en allemand, et couvre les districts de la Sarine, de la Gruyère, du Lac, de la Glâne, de la Singine, de la Veveyse et de la Broye.",
        miniFaq: [
            {
                q: "Intervenez-vous en français et en allemand dans le canton de Fribourg ?",
                a: "Oui. Nos collaborateurs sont bilingues français/allemand — un atout dans les districts alémaniques (Singine, Lac) et dans les communes bilingues comme Morat ou Fribourg-ville.",
            },
            {
                q: "Rachat rapide à Bulle et dans la Gruyère ?",
                a: "Oui, la Gruyère fait partie de notre zone standard : intervention à Bulle, Charmey, Broc ou La Roche généralement sous 24 à 48h, déplacement gratuit inclus.",
            },
            {
                q: "Combien de temps entre l'appel et l'offre à Fribourg ?",
                a: "Une offre indicative en 5 minutes par téléphone au 076 442 58 04, et une offre ferme écrite sous 24h après votre demande en ligne. La reprise s'organise ensuite au créneau qui vous convient.",
            },
            {
                q: "Rachetez-vous dans les zones rurales du canton ?",
                a: "Oui, sans surcoût, y compris dans les zones plus rurales (Veveyse, Broye, hauts de la Gruyère). Le déplacement gratuit s'applique à l'ensemble du canton de Fribourg.",
            },
        ],
    },
    neuchatel: {
        slug: "neuchatel",
        name: "Neuchâtel",
        short: "NE",
        mainCity: "Neuchâtel",
        h1: "Rachat de voiture dans le canton de Neuchâtel",
        locationLabel: "dans le canton de Neuchâtel",
        finalCtaTitle: "Vendez votre voiture dans le canton de Neuchâtel en 24h",
        metaTitle: "Rachat voiture Neuchâtel — Cash en 24h | Capital Automobile",
        metaDescription:
            "Rachat voiture canton de Neuchâtel : Neuchâtel, La Chaux-de-Fonds, Le Locle. Offre cash en 24h, déplacement gratuit dans le Littoral et les Montagnes.",
        intro:
            "Capital Automobile rachète votre voiture dans le canton de Neuchâtel, du Littoral aux Montagnes neuchâteloises. Nous nous déplaçons gratuitement à Neuchâtel, La Chaux-de-Fonds, Le Locle, Boudry, Peseux ou dans n'importe quelle autre commune du canton. Notre offre est ferme sous 24h, le paiement se fait cash le jour de la prise en charge, et nous nous occupons de la désimmatriculation auprès du Service cantonal des automobiles et de la navigation.",
        cities: [
            "Neuchâtel",
            "La Chaux-de-Fonds",
            "Le Locle",
            "Val-de-Travers",
            "Boudry",
            "Peseux",
            "Cortaillod",
            "Marin-Epagnier",
            "Hauterive",
            "Cornaux",
        ],
        trust:
            "Les Montagnes neuchâteloises, leur climat et leurs longues distances, nous les connaissons. Que vous habitiez La Chaux-de-Fonds, Le Locle ou le Val-de-Travers, notre équipe planifie son déplacement avec la même réactivité qu'au bord du lac, et adapte son rendez-vous aux conditions hivernales.",
        miniFaq: [
            {
                q: "Rachetez-vous à La Chaux-de-Fonds et au Locle ?",
                a: "Oui, gratuitement — La Chaux-de-Fonds et Le Locle font partie de notre zone standard. L'intervention y est souvent planifiée dans les 48h qui suivent votre demande.",
            },
            {
                q: "Combien de temps pour un rachat dans les Montagnes neuchâteloises ?",
                a: "Offre ferme sous 24h après votre demande, et déplacement sur place dans les 48h en général — sauf conditions de route hivernales très défavorables, auquel cas nous décalons de quelques heures.",
            },
            {
                q: "Voitures adaptées aux hivers rigoureux : quelle décote ?",
                a: "Les 4x4 et SUV utilisés dans les Montagnes gardent une bonne valeur, notamment à l'export. La décote dépend surtout de l'état mécanique et du kilométrage — le climat en lui-même n'entraîne pas de pénalité systématique.",
            },
            {
                q: "Intervention sur le Littoral neuchâtelois ?",
                a: "Oui, gratuitement à Neuchâtel, Boudry, Peseux, Cortaillod, Marin-Epagnier ou Hauterive. Le Littoral est notre zone la plus rapidement accessible du canton.",
            },
        ],
    },
    valais: {
        slug: "valais",
        name: "Valais",
        short: "VS",
        mainCity: "Sion",
        h1: "Rachat de voiture dans le canton du Valais",
        locationLabel: "dans le canton du Valais",
        finalCtaTitle: "Vendez votre voiture dans le canton du Valais en 24h",
        metaTitle: "Rachat voiture Valais — Cash en 24h | Capital Automobile",
        metaDescription:
            "Rachat voiture en Valais : Sion, Martigny, Sierre, Monthey, Brigue. Spécialistes 4x4 et véhicules de montagne. Paiement cash sous 24h.",
        intro:
            "Capital Automobile rachète votre voiture dans tout le canton du Valais, du Bas-Valais au Haut-Valais : Sion, Martigny, Sierre, Monthey, Brigue, Viège ou Conthey. Spécialistes des véhicules de montagne, des 4x4 et utilitaires, nous savons valoriser les voitures à fort kilométrage, accidentées ou destinées à l'export. Déplacement gratuit dans toutes les vallées et la plaine du Rhône, offre cash sous 24 heures et prise en charge des démarches administratives auprès du Service de la circulation routière.",
        cities: [
            "Sion",
            "Martigny",
            "Sierre",
            "Monthey",
            "Brigue",
            "Viège",
            "Conthey",
            "Saint-Maurice",
            "Saxon",
            "Naters",
        ],
        trust:
            "Le Valais, c'est la plaine du Rhône, les hauts plateaux et les vallées latérales — nous y intervenons sans surcoût. Spécialistes des 4x4, des SUV et des véhicules à fort kilométrage typiques des routes alpines, nous proposons une expertise locale et un déplacement gratuit même à Brigue ou en val d'Anniviers.",
        miniFaq: [
            {
                q: "Rachetez-vous les 4x4 et SUV valaisans ?",
                a: "Oui, c'est même l'une de nos spécialités en Valais. Les 4x4 et SUV utilisés en montagne sont très recherchés à l'export, ce qui limite la décote même à fort kilométrage.",
            },
            {
                q: "Combien pour une voiture ayant beaucoup roulé en montagne ?",
                a: "Le kilométrage n'est jamais un blocage : nous rachetons couramment des véhicules valaisans à plus de 200 000 km. Le prix dépend surtout de l'état mécanique et de la demande sur les marchés d'export.",
            },
            {
                q: "Intervenez-vous à Brigue et dans le Haut-Valais ?",
                a: "Oui, gratuitement. Brigue, Viège, Naters et l'ensemble du Haut-Valais font partie de notre zone couverte — nos équipes sont à l'aise en français comme en allemand.",
            },
            {
                q: "Rachat cash à Sion et Martigny sous 24h ?",
                a: "Oui, Sion et Martigny sont accessibles sous 24 à 48h. Offre ferme le jour de la demande, reprise sur place avec paiement cash ou virement instantané le lendemain ou surlendemain.",
            },
        ],
    },
};

export const CANTON_SLUGS = ["vaud", "geneve", "fribourg", "neuchatel", "valais"];
